"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFederatedSearchIntegrationPanel = getFederatedSearchIntegrationPanel;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _FederatedSearchSyncStatus = _interopRequireDefault(require("./FederatedSearchSyncStatus"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _constants = require("@insided/shared/constants");

/* eslint-disable import/prefer-default-export */
function getFederatedSearchIntegrationPanel(props) {
  var isInstalled = props.isInstalled,
      isSettingEnabled = props.isSettingEnabled,
      onSave = props.onSave,
      onCancel = props.onCancel,
      onSettingChanged = props.onSettingChanged,
      showActionButtons = props.showActionButtons,
      hasUnsavedChanges = props.hasUnsavedChanges,
      onClickPanelCallback = props.onClickPanelCallback,
      storedState = props.storedState,
      language = props.language,
      categories = props.categories,
      _onLanguageChanged = props.onLanguageChanged,
      _onCategoriesChanged = props.onCategoriesChanged,
      _onLanguageInputClicked = props.onLanguageInputClicked,
      _onCategoriesInputClicked = props.onCategoriesInputClicked,
      federatedSearchSyncInProgress = props.federatedSearchSyncInProgress,
      isSavingFederatedSearchSetting = props.isSavingFederatedSearchSetting;
  return (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Zendesk federated search',
    isInstalled: isInstalled,
    isSettingEnabled: isSettingEnabled,
    imageFromName: 'zendesk-guide-s',
    imageToName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    onSettingChanged: onSettingChanged,
    onSave: onSave,
    onCancel: onCancel,
    showActionButtons: showActionButtons,
    toggleLabel: 'Enable Zendesk federated search',
    communityArticleLink: 'https://community.insided.com/integrations-124/search-for-zendesk-guide-content-through-your-community-a-brief-tutorial-1846',
    description: "Empower end users to search Zendesk Guide Help Center content through ".concat(_constants.PLATFORM_BRAND_NAME, "."),
    storedIsSettingEnabled: storedState.isFederatedSearchActive,
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: 'qa-federated-search',
    onClickPanel: onClickPanelCallback,
    additionalHelpText: (0, _preact.h)(AdditionalHelpText, null),
    additionalInputFields: (0, _preact.h)(AdditionalInputFields, {
      onLanguageChanged: function onLanguageChanged(value) {
        return _onLanguageChanged(value);
      },
      language: language,
      onCategoriesChanged: function onCategoriesChanged(value) {
        return _onCategoriesChanged(value);
      },
      categories: categories,
      onLanguageInputClicked: function onLanguageInputClicked() {
        return _onLanguageInputClicked();
      },
      onCategoriesInputClicked: function onCategoriesInputClicked() {
        return _onCategoriesInputClicked();
      }
    }),
    integrationStatus: (0, _preact.h)(_FederatedSearchSyncStatus.default, {
      isFederatedSearchActive: storedState.isFederatedSearchActive,
      federatedSearchSyncInProgress: federatedSearchSyncInProgress
    }),
    isLoading: isSavingFederatedSearchSetting
  });
}

var AdditionalHelpText = function AdditionalHelpText() {
  var communityUrl = (0, _globals.default)('communityUrl');
  return (0, _preact.h)("span", null, "View Zendesk Guide Help Center content in the", ' ', (0, _preact.h)("a", {
    className: "overview-page-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(communityUrl.concat('/search')),
    rel: "noreferrer",
    target: "_blank"
  }, "search result"), ' ', "on the community destination.", ' ');
};

var AdditionalInputFields = function AdditionalInputFields(_ref) {
  var language = _ref.language,
      categories = _ref.categories,
      onLanguageChanged = _ref.onLanguageChanged,
      onCategoriesChanged = _ref.onCategoriesChanged,
      onLanguageInputClicked = _ref.onLanguageInputClicked,
      onCategoriesInputClicked = _ref.onCategoriesInputClicked;
  return (0, _preact.h)("div", null, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Filter by language",
    optional: true,
    meta: "Enter locale parameter of the language that you want to show in federated search.",
    placeholder: "e.g. en-us",
    qaClasses: "qa-language",
    value: language,
    onChangeCallback: function onChangeCallback(e) {
      return onLanguageChanged(e.target.value);
    },
    onClick: function onClick() {
      return onLanguageInputClicked();
    }
  }), (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Filter by category",
    optional: true,
    meta: "Enter the category IDs of the categories that you want to show in federated search, separated by comma.",
    qaClasses: "qa-categories",
    placeholder: "e.g. 123456, 234567",
    value: categories,
    onChangeCallback: function onChangeCallback(e) {
      return onCategoriesChanged(e.target.value);
    },
    onClick: function onClick() {
      return onCategoriesInputClicked();
    }
  }));
};